import validation from "vee-validate/dist/locale/it.json";
export const vee_validate = {
    fields: {
        lastname: "cognome",
        firstname: "nome",
        email: "e-mail",
        gender: "sexo",
        optin_terms_conditions: "condizioni generali",
        optin_privacy:"informativa sulla privacy",

        street:"via",
        zip_code:"codice postale",
        city:"città",

        phone:"telemóvel",

        iban:"iban",
        codice_fiscale:"codice fiscale",
    },
    validation: {
        ...validation.messages,
        minmax: 'The {_field_} field must have at least {min} characters and {max} characters at most',
        fraud: 'Il {_field_} non è valido'
    }
}
